import { AxiosError } from "axios";
import Cookies from "js-cookie";
import { useQuery, UseQueryResult, UseBaseQueryOptions } from "react-query";
import { AuthCsrfRepository } from "../AuthCsrfRepository";
import { AuthCsrfSerializer } from "../serializer-types";

const repo = new AuthCsrfRepository();

// Mainly used to set cookies for our vercel preview sites so that the next
// server has access to these tokens to make server side calls
// or anywhere the server is running on a different url than the cookies are located
const useCsrfTokens = (
  queryOptions?: UseBaseQueryOptions<AuthCsrfSerializer, AxiosError>
): UseQueryResult<AuthCsrfSerializer, AxiosError> => {
  return useQuery<AuthCsrfSerializer, AxiosError>(
    ["csrfTokens"],
    () => {
      return repo.retrieve().then((response) => {
        Cookies.set("csrftoken", response.csrfToken);
        Cookies.set("sessionid", response.session_id);

        return response;
      });
    },
    {
      refetchOnWindowFocus: false,
      ...queryOptions,
    }
  );
};

export default useCsrfTokens;
